<template>
  <div class="page sear">
    <div class="top">
      <div class="actions">
        <div class="back" @click="$emit('clear')">Voltar</div>
      </div>
    </div>
    <div class="content" v-if="res.length">
      <div class="box" v-for="(n, index) in res" :key="index">
        <RouterLink :to="{ path: `${n.router}/${n.id}/${n.url}`, name: n.name, params: { id: n.id, url: n.url } }">
          <div class="img" :style="{ backgroundImage: 'url(' + n.imagem + ')' }"></div>
          <div class="title nobr">{{ n.titulo }}</div>
        </RouterLink>
      </div>
    </div>
    <div class="content empty" v-else>
      <p>Nada encontrado para "{{ search }}"</p>
    </div>
  </div>
</template>

<script setup>

import { search as apiSearch } from '@/services/api.js'
import { trackEvent } from '@/services/analytics.js'
import { ref } from 'vue'

const props = defineProps(['search'])

const res = ref([])

async function getSearch() {
  res.value = await apiSearch(props.search)
  trackEvent('search', {
    search_term_length: props.search.length,
    results_count: res.value.length,
  })
}

getSearch()
</script>

<style scoped>
.sear .top .actions .back {
  float: left;
  width: auto;
  height: 40px;
  color: #fff;
  background-color: var(--color1);
  border-radius: 20px;
  padding: 0 16px;
  font-weight: 600;
  font-size: 14px;
  line-height: 40px;
  user-select: none;
}
</style>
